<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>设备管理</el-breadcrumb-item>
            <el-breadcrumb-item>大华摄像头</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <br>
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20">
                <el-col :span="22">
                    <el-input placeholder="请输入店名/大华摄像头SN" clearable v-model="queryInfo.query" @clear="getList()" style="width: 500px;">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="2">
                    <el-button type="primary" icon="el-icon-refresh" @click="getList()" v-permission="'btn:dahua:refresh'">刷新</el-button>
                </el-col>
            </el-row>
            <!--搜索与添加区域-->
            <br>
            <!--用户列表区域-->
            <el-table v-loading="loading" :data="list"  :key="list.index" style="width: 100%" stripe size="middle" height="780">
                <el-table-column label="ID" type="index"  width="100"></el-table-column>
                <el-table-column label="门店名称" prop="storename" width="400"></el-table-column>
                <el-table-column label="大华摄像头SN" prop="sn" width="400"></el-table-column>
                <el-table-column label="人数" prop="people_count"  width="400">
                    <template  slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.people_count == 0 ">{{scope.row.people_count}}</el-tag>
                        <el-tag type="danger" v-else>{{scope.row.people_count}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="刷新时间" prop="time">
                    <template slot-scope="scope">
                        {{ formatTime(scope.row.time) }}
                    </template>
                </el-table-column>
            </el-table>
            <!--用户列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum" :page-sizes="[50,500,1000]"  :page-size="queryInfo.pagesize" 
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        return{
            queryInfo: {
                query: '',
                pagenum: 1,
                pagesize: 50
            },
            total:0,
            list: [],
            loading:false
        }
        
    },
    created() {
         this.getList()
    },
    methods:{
        formatTime(timestamp) {
            // 检查时间戳是否有效
            if (!timestamp || isNaN(timestamp)) {
                return '无效时间';
            }
            // 转换为数字，确保是毫秒级
            const msTimestamp = Number(timestamp);
            const date = new Date(msTimestamp);
            // 验证 Date 对象是否有效
            if (isNaN(date.getTime())) {
                return '无效时间';
            }
            return date.toLocaleString('zh-CN', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            }).replace(/\//g, '-'); // 输出如：2025-04-24 14:34:39
        },
        async getList() {
            this.loading = true
           const { data: res} = await this.$http.get('dahualist/',{ params: this.queryInfo })
           if(res.status == 1){
                this.list = res.data
                this.total = res.data.length
                this.loading = false
            }
        },
        handleSizeChange(newSize){
           this.queryInfo.pagesize = newSize
           this.getList()
       },
       handleCurrentChange(newPage){
           this.queryInfo.pagenum = newPage
           this.getList()
       }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    .el-table::before {
    height: 0px;
    
    }
</style>